import { h, defineAsyncComponent } from 'vue'
import { useRouter } from 'vue-router'

// Helper function to resolve the layout component
function resolveLayoutComponent (layout) {
  // Lazy-load the layout component correctly
  return defineAsyncComponent(() => import(`../layouts/${layout}.vue`))
}

// Layout resolver component wrapper
export default {
  name: 'LayoutResolver',
  setup () {
    const router = useRouter()
    return { router }
  },
  render () {
    // Get the layout specified on the route, or fallback to default
    const currentRoute = this.router?.currentRoute
    // Safely access meta and layout, with fallback to DefaultLayout
    const layout = currentRoute?.value?.meta?.layout || 'DefaultLayout'

    // Dynamically import the specified layout
    const layoutComponent = resolveLayoutComponent(layout)

    // Render the layout with the page content as the default slot
    // Ensure we check if this.$slots.default is a function before calling it
    return h(layoutComponent, null, {
      default: () => typeof this.$slots.default === 'function' ? this.$slots.default() : this.$slots.default
    })
  }
}
